import { render, staticRenderFns } from "./VFooter.vue?vue&type=template&id=214d4757&scoped=true"
import script from "./VFooter.vue?vue&type=script&lang=js"
export * from "./VFooter.vue?vue&type=script&lang=js"
import style0 from "./VFooter.vue?vue&type=style&index=0&id=214d4757&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d4757",
  null
  
)

export default component.exports